import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, AlertTriangle } from 'lucide-react';

// 플랫폼 종료 공지 배너 — 모든 페이지 상단에 표시. 하루 동안 닫기 가능.
const STORAGE_KEY = 'latteis-sunset-banner-dismissed-until';
const SUNSET_DATE_LABEL = '2026년 12월 31일';
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000; // 1일

const SunsetBanner = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const dismissedUntil = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    if (Date.now() > dismissedUntil) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + DISMISS_DURATION_MS));
    setVisible(false);
  };

  const handleGoToDocuments = () => {
    navigate('/documents');
  };

  if (!visible) return null;

  return (
    <div
      role="alert"
      className="w-full bg-amber-50 border-b border-amber-300 text-amber-900 text-sm"
    >
      <div className="max-w-screen-xl mx-auto flex items-center gap-3 px-4 py-2.5">
        <AlertTriangle size={18} className="flex-shrink-0 text-amber-600" aria-hidden="true" />
        <div className="flex-1 leading-snug">
          <strong className="font-semibold">서비스 종료 안내:</strong>{' '}
          라떼이즈는 <strong>{SUNSET_DATE_LABEL}</strong>까지만 운영됩니다.
          그 전에 작성하신 이력서를 반드시 다운로드해 주세요.
        </div>
        <button
          type="button"
          onClick={handleGoToDocuments}
          className="hidden sm:inline-flex items-center rounded-md bg-amber-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-amber-700"
        >
          내 이력서 보기
        </button>
        <button
          type="button"
          aria-label="공지 닫기 (24시간 동안 숨김)"
          onClick={handleDismiss}
          className="flex-shrink-0 rounded-md p-1 text-amber-700 hover:bg-amber-100"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default SunsetBanner;
